const txt = 'La musique a toujours été mon passe-temps favori. Je suis toujours à la recherche de nouveautés musicales, et ce dans tous les styles musicaux. Voici quelques uns de mes différents coups de coeur musicaux que je souhaite partager, en passant de la musique électronique au néoclassique. N’hésitez surtout pas si vous avez des recommandations à me faire!';

export default txt;
